import React from 'react';
import { HtmlHeadInclude } from '@msdyn365-commerce/core';

export default function ServerSideRedirect({ redirectUrl }: { redirectUrl: string }) {
    return (
        <HtmlHeadInclude>
            <script
                data-load-point='headStart'
                dangerouslySetInnerHTML={{
                    __html: `window.location.replace(${JSON.stringify(redirectUrl)});`
                }}
            />
        </HtmlHeadInclude>
    );
}
